import React, { useState } from "react";
import { auth, db, googleProvider } from "../../firebase";
import {
  createUserWithEmailAndPassword,
  signInWithPopup,
  signOut,
} from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { FaUser, FaUserTie } from "react-icons/fa";
import { sendEmailVerification } from "firebase/auth";

const Register = () => {
  const [role, setRole] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mobile, setMobile] = useState("");
  const [message, setMessage] = useState("");
  const [useMobileRegister, setUseMobileRegister] = useState(false);
  const navigate = useNavigate();

  const generateAccountId = (role) => {
    const prefix = role === "agent" ? "A" : "U";
    return prefix + Math.floor(100000 + Math.random() * 900000);
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      const userRef = doc(db, "users", user.uid);
      const existingDoc = await getDoc(userRef);

      if (existingDoc.exists()) {
        setMessage(
          <>
            User already registered.{" "}
            <a href="/login" className="text-primary text-decoration-underline">
              Go to Login
            </a>
          </>
        );
        await signOut(auth);
        return;
      }

      const accountId = generateAccountId(role);

      const baseData = {
        uid: user.uid,
        accountId,
        email,
        role,
        isActive: true,
        downloads: [],
        area: "",
        mandal: "",
        district: "",
        state: "",
        mobile,
      };

      const userData =
        role === "agent"
          ? {
              ...baseData,
              username: email,
              contact: mobile,
              credits: 0,
              printStyle: "",
            }
          : baseData;

      await setDoc(userRef, userData);
      await sendEmailVerification(user); // ✅ Correct usage
      navigate("/settings"); // ✅ Redirect before sign out
      // await signOut(auth); // Optional: remove if you want user to stay logged in
    } catch (error) {
      setMessage(error.message);
    }
  };

  const handleGoogleRegister = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      const userRef = doc(db, "users", user.uid);
      const existingDoc = await getDoc(userRef);

      if (existingDoc.exists()) {
        setMessage(
          <>
            User already registered.{" "}
            <a href="/login" className="text-primary text-decoration-underline">
              Go to Login
            </a>
          </>
        );
        await signOut(auth);
        return;
      }

      const accountId = generateAccountId(role);

      const baseData = {
        uid: user.uid,
        accountId,
        email: user.email,
        role,
        isActive: true,
        downloads: [],
        area: "",
        mandal: "",
        district: "",
        state: "",
        mobile: user.phoneNumber || "",
        username: user.profilename,
      };

      const userData =
        role === "agent"
          ? {
              ...baseData,
              username: "",
              contact: user.phoneNumber || "",
              credits: 0,
              printStyle: "",
            }
          : baseData;

      await setDoc(userRef, userData);
      navigate("/settings");
    } catch (error) {
      setMessage(error.message);
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "80vh" }}
    >
      <div
        className="card shadow-lg p-4"
        style={{ width: "100%", maxWidth: "500px" }}
      >
        <h3 className="text-center mb-4 text-primary">Register</h3>

        <div className="mb-3">
          <label className="form-label">Register as</label>
          <select
            className="form-select"
            value={role}
            onChange={(e) => setRole(e.target.value)}
          >
            <option value="">Select</option>
            <option value="user">👤 User</option>
            <option value="agent">🧑‍💼 Agent</option>
          </select>
        </div>

        {/* {role && !useMobileRegister && (
          <form onSubmit={handleRegister}>
            <div className="mb-3">
              <label className="form-label">Email address</label>
              <div className="input-group">
                <span className="input-group-text">
                  <FaUser />
                </span>
                <input
                  type="email"
                  className="form-control"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">Password</label>
              <input
                type="password"
                className="form-control"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Mobile Number</label>
              <input
                type="tel"
                className="form-control"
                required
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
              />
            </div>

            <button type="submit" className="btn btn-danger w-100 mb-3">
              Register with Email
            </button>
          </form>
        )} */}

        {role && !useMobileRegister && (
          <form onSubmit={handleRegister}>
            <div className="mb-3">
              <label className="form-label">Email address</label>
              <div className="input-group">
                <span className="input-group-text">
                  <FaUser />
                </span>
                <input
                  type="email"
                  className="form-control"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">Password</label>
              <input
                type="password"
                className="form-control"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            {/* <div className="mb-3">
              <label className="form-label">Mobile Number</label>
              <input
                type="tel"
                className="form-control"
                required
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
              />
            </div> */}

            <button type="submit" className="btn btn-primary w-100 mb-3">
              Register with Email
            </button>
          </form>
        )}

        {role && useMobileRegister && (
          <div className="alert alert-info text-center">
            Mobile registration is not implemented in this version.
            <br />
            Please use email or Google to register.
          </div>
        )}

        {role && (
          <div className="d-flex justify-content-between gap-2 mt-2">
            <button
              className="btn btn-outline-secondary w-100"
              onClick={() => setUseMobileRegister(!useMobileRegister)}
            >
              {useMobileRegister
                ? "Register with Email"
                : "Register with Mobile"}
            </button>

            <button
              type="button"
              className="btn btn-outline-danger w-100"
              onClick={handleGoogleRegister}
            >
              Register with Google
            </button>
          </div>
        )}

        {message && (
          <div className="alert alert-info mt-3 text-center">{message}</div>
        )}

        <div className="text-center mt-3">
          Already registered? <a href="/login">Go to Login</a>
        </div>
      </div>
    </div>
  );
};

export default Register;
